module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"period":"期間","err_period":"指定できる期間は最長3年間（36ヶ月）です"},"en":{"period":"Period","err_period":"You can specify a maximum period of 3 years (36 months)"}}')
  delete Component.options._Ctor
}
